// import { useEffect, useState } from "react";
// import { fetchUsers, sendActivatedEmail, sendDeactivatedEmail, setUserActive } from "../utils/api";
// import "./admin.css";

// export default function Users() {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const load = async () => {
//     setLoading(true);
//     const data = await fetchUsers();
//     setUsers(data);
//     setLoading(false);
//   };

//   useEffect(() => {
//     load();
//   }, []);

//   const toggle = async (user) => {
//     console.log(user)
//   const confirmMsg = user.active
//     ? "Deactivate this user?"
//     : "Activate this user?";

//   if (!window.confirm(confirmMsg)) return;

//   try {
//     // 1️⃣ Update user active status
//     await setUserActive(user.id, !user.active);

//     // 2️⃣ Send email based on action
//     if (!user.active) {
//       // activating

//       await sendActivatedEmail(user.email, user.lang || "en");
//     } else {
//       // deactivating
//       await sendDeactivatedEmail(user.email, user.lang || "en");
//     }

//     // 3️⃣ Reload users
//     load();
//   } catch (err) {
//     alert(err.message);
//   }
// };


//   return (
//     <div className="users-page">
//       <div className="page-header">
//         <h1 className="page-title">Users</h1>
//         <p className="page-subtitle">
//           Manage user access and account status
//         </p>
//       </div>

//       {loading ? (
//         <p>Loading users…</p>
//       ) : (
//         <div className="table-wrapper">
//           <table className="users-table">
//             <thead>
//               <tr>
//                 <th>Email</th>
//                 <th>Name</th>
//                 <th>Status</th>
//                 <th style={{ width: "140px" }}>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {users.map((u) => (
//                 <tr key={u.id}>
//                   <td>{u.email}</td>
//                   <td>{u.name || "—"}</td>
//                   <td>
//                     <span
//                       className={`status-badge ${
//                         u.active ? "active" : "inactive"
//                       }`}
//                     >
//                       {u.active ? "Active" : "Inactive"}
//                     </span>
//                   </td>
//                   <td>
//                     <button
//                       className={`action-btn ${
//                         u.active ? "deactivate" : "activate"
//                       }`}
//                       onClick={() => toggle(u)}
//                     >
//                       {u.active ? "Deactivate" : "Activate"}
//                     </button>
//                   </td>
//                 </tr>
//               ))}

//               {users.length === 0 && (
//                 <tr>
//                   <td colSpan="4" className="empty">
//                     No users found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       )}
//     </div>
//   );
// }
import { useEffect, useState } from "react";
import {
  fetchUsers,
  sendActivatedEmail,
  sendDeactivatedEmail,
  setUserActive,
} from "../utils/api";
import "./admin.css";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoadingId, setActionLoadingId] = useState(null); // 👈 NEW

  const load = async () => {
    setLoading(true);
    const data = await fetchUsers();
    setUsers(data);
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  const toggle = async (user) => {
    const confirmMsg = user.active
      ? "Deactivate this user?"
      : "Activate this user?";

    if (!window.confirm(confirmMsg)) return;

    try {
      setActionLoadingId(user.id); // 👈 start loading for this row

      // 1️⃣ Update user active status
      await setUserActive(user.id, !user.active);

      // 2️⃣ Send email
      if (!user.active) {
        await sendActivatedEmail(user.email, user.lang || "en");
      } else {
        await sendDeactivatedEmail(user.email, user.lang || "en");
      }

      // 3️⃣ Reload users
      await load();
    } catch (err) {
      alert(err.message);
    } finally {
      setActionLoadingId(null); // 👈 stop loading
    }
  };

  return (
    <div className="users-page">
      <div className="page-header">
        <h1 className="page-title">Users</h1>
        <p className="page-subtitle">
          Manage user access and account status
        </p>
      </div>

      {loading ? (
        <p>Loading users…</p>
      ) : (
        <div className="table-wrapper">
          <table className="users-table">
            <thead>
              <tr>
                <th>Email</th>
                <th>Name</th>
                <th>Status</th>
                <th>Phone</th>
                <th style={{ width: "160px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => {
                const isBusy = actionLoadingId === u.id;

                return (
                  <tr key={u.id}>
                    <td>{u.email}</td>
                    <td>{u.name || "—"}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          u.active ? "active" : "inactive"
                        }`}
                      >
                        {u.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td>{u.phone}</td>
                    <td>
                      <button
                        className={`action-btn ${
                          u.active ? "deactivate" : "activate"
                        }`}
                        onClick={() => toggle(u)}
                        disabled={isBusy}
                      >
                        {isBusy
                          ? u.active
                            ? "Deactivating…"
                            : "Activating…"
                          : u.active
                          ? "Deactivate"
                          : "Activate"}
                      </button>
                    </td>
                  </tr>
                );
              })}

              {users.length === 0 && (
                <tr>
                  <td colSpan="4" className="empty">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
